import DOMPurify from 'dompurify';
export function parseBBCode(str) {
  if (str === undefined || str === null || str === '') {
    return '';
  }
  const from = BBCODE_TAGS;

  const to = HTML_TAGS;

  for (let i = 0; i < from.length; i++) {
    // let regex = new RegExp(from[i], 'igm');
    //Safely escape bbcode symbols # From SO: https://stackoverflow.com/questions/17885855/use-dynamic-variable-string-as-regex-pattern-in-javascript
    const escapedFrom = from[i].replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    let regex = new RegExp(escapedFrom, 'igm');
    str = str.replace(regex, to[i]);
  }
  str = DOMPurify.sanitize(str);
  // console.log('String', str);
  return str;
}

export const BBCODE_TAGS = [
  // Standard Typography
  '[b]',
  '[/b]',
  '[i]',
  '[/i]',
  '[u]',
  '[/u]',
  '[p]',
  '[/p]',
  '[br]',
  //Headings
  '[h1]',
  '[/h1]',
  '[h2]',
  '[/h2]',
  '[h3]',
  '[/h3]',
  '[h4]',
  '[/h4]',
  '[h5]',
  '[/h5]',
];

export const HTML_TAGS = [
  //Standard Typography
  '<strong>',
  '</strong>',
  '<em>',
  '</em>',
  '<span class="underlined-text">',
  '</span>',
  '<p>',
  '</p>',
  '<br />',
  //Headings
  '<h2>',
  '</h2>',
  '<h3>',
  '</h3>',
  '<h4>',
  '</h4>',
  '<h5>',
  '</h5>',
  '<h6>',
  '</h6>',
];
